import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "top-search" }
const _hoisted_2 = {
  key: 0,
  class: "top-search-results"
}
const _hoisted_3 = ["onMousedown", "onMouseenter"]
const _hoisted_4 = { class: "top-search-name" }
const _hoisted_5 = { class: "top-search-type" }
const _hoisted_6 = {
  key: 0,
  class: "top-search-reason"
}
const _hoisted_7 = {
  key: 0,
  class: "top-search-status"
}
const _hoisted_8 = {
  key: 1,
  class: "top-search-status"
}
const _hoisted_9 = {
  key: 2,
  class: "top-search-status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "Search",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.q) = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInput())),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = !!_ctx.q.trim())),
      onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onKeydown($event)))
    }, null, 544), [
      [_vModelText, _ctx.q]
    ]),
    (_ctx.open && _ctx.q.trim().length >= 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (node, i) => {
            return (_openBlock(), _createElementBlock("a", {
              key: node.Slug,
              class: _normalizeClass(i == _ctx.highlighted ? 'on' : ''),
              onMousedown: _withModifiers(($event: any) => (_ctx.select(node)), ["prevent"]),
              onMouseenter: ($event: any) => (_ctx.highlighted = i)
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(node.Name), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.typeLabel(node.Type)), 1),
              (node.Reason)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(node.Reason), 1))
                : _createCommentVNode("", true)
            ], 42, _hoisted_3))
          }), 128)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Searching…"))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
              : (!_ctx.results.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "No matches found"))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}